import { CancelToken } from 'axios';
import { awPortfolioManagementApi } from '../Base';
import { AgraphBatchGetModelsRequestBody, AgraphBatchGetModelsResponseBody } from '../types';

const MODELS_PATH = 'models/v1/models';

export function postBatchGetModels(getModelsRequest: AgraphBatchGetModelsRequestBody, cancelToken?: CancelToken) {
  const path = `${MODELS_PATH}:batchGet`;
  return awPortfolioManagementApi.post<AgraphBatchGetModelsResponseBody>(path, getModelsRequest, {
    cancelToken,
  });
}
